export const TripServiceProvider = {
    MILES: 'Miles',
    DOTT: 'Dott',
    ...(process.env.REACT_APP_STAGE !== 'prod' && { EMULATOR: 'MSP_Emulator' })
}

export const TripServiceProviderKeys = Object.keys(TripServiceProvider);

export type FilterTripHistoryServiceProviderTypes = keyof (typeof TripServiceProvider) | 'ALL';
export type FilterTripServiceProviderTypes = keyof (typeof TripServiceProvider) | null;
